import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// Images & Videos
import cute_family_bg_remove from "../assets/cute_family.jpg";
import parkVideo from "../assets/park_video.mp4";

// CSS
import "./About.css";
import "./About-1.css";
import "./FAQSection.css";

// Icons
import {
  FaDraftingCompass,
  FaProjectDiagram,
  FaPlug,
  FaTools,
  FaHome,
  FaCouch,
  FaLightbulb,
  FaRulerCombined,
  FaCogs,
} from "react-icons/fa";

const AboutUs = () => {
  const [activeTab] = useState("planning");
  const [phVisible, setPhVisible] = useState([false, false, false, false, false]);
  const skillRefs = useRef([]);

  const skillData = [
    { label: "HTML5 & CSS3", width: 96 },
    { label: "Sass & Less", width: 85 },
    { label: "Bootstrap", width: 88 },
    { label: "JavaScript", width: 90 },
    { label: "AutoCAD Civil Arch", width: 92 },
    { label: "Google SketchUp", width: 85 },
    { label: "Lumion", width: 80 },
    { label: "Revit Architecture", width: 78 },
    { label: "Technical Drawing", width: 90 },
    { label: "Problem-Solving", width: 88 },
    { label: "Drafting", width: 93 },
    { label: "Attention to Detail", width: 95 },
  ];

  useEffect(() => {
    phVisible.forEach((v, i) => {
      setTimeout(() => {
        setPhVisible((prev) => {
          const arr = [...prev];
          arr[i] = true;
          return arr;
        });
      }, i * 180 + 200);
    });
  }, []);

  useEffect(() => {
    skillRefs.current.forEach((ref, i) => {
      if (ref) {
        ref.style.width = "0%";
        setTimeout(() => {
          ref.style.transition = "width 1.2s ease";
          ref.style.width = skillData[i].width + "%";
        }, 200 + i * 120);
      }
    });
  }, []);

  return (
    <div className="about_main">
      {/* 🏡 Section: Intro & Family */}
      <div className="about-1">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 p-0">
              <div className="cute-family d-flex align-items-end h-100">
                <img
                  src={cute_family_bg_remove}
                  alt="Happy family"
                  className="img-fluid w-100"
                  style={{ objectFit: "cover", height: "100%" }}
                />
              </div>
            </div>

            <div className="col-md-6 about-1-content d-flex flex-column justify-content-center p-5">
              <h2 className="mb-3">About Us</h2>
              <p className="lead fw-semibold">TO INVEST IN A LIFETIME OF HAPPINESS.</p>
              <p>
                Lavoura Group provides a fully secure lifestyle with a plethora of impressive
                amenities — from well-demarcated plots to wide internal roads, from beautifully
                landscaped greens to the latest essential infrastructure.
              </p>

              <div className="mt-4">
                <div className="d-flex align-items-start mb-3">
                  <span className="me-3 fs-3 text-success" role="img" aria-label="Home">🏡</span>
                  <div>
                    <h6 className="mb-1">Modern Villa</h6>
                    <small>We provide you the best construction of villas.</small>
                  </div>
                </div>
                <div className="d-flex align-items-start">
                  <span className="me-3 fs-3 text-success" role="img" aria-label="Card">💳</span>
                  <div>
                    <h6 className="mb-1">Secure Payment</h6>
                    <small>Transparent transactions for peace of mind.</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* 🌟 Section: Hero Banner with Video */}
      <div className="hero-banner position-relative text-white d-flex align-items-center justify-content-center text-center">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="video-bg position-absolute w-100 h-100"
          style={{ objectFit: "cover", top: 0, left: 0, zIndex: 0 }}
        >
          <source src={parkVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="hero-overlay position-relative" style={{ zIndex: 2 }}>
          <h1>About Nandanam Infra – River Front</h1>
          <p className="lead">Building Dreams on the Banks of Progress</p>
          <div className="mt-4">
            <button className="btn btn-success me-3">View Our Projects</button>
            <button className="btn btn-outline-light">Contact Us</button>
          </div>
        </div>
      </div>


      {/* 🌿 Section: Mission & Vision */}
      <section className="mission-vision py-5">
        <div className="container text-center">
          <div className="row">
            <div className="col-md-6">
              <div className="card shadow p-4 h-100">
                <h4 className="text-success">Our Mission</h4>
                <p>
                  To empower every family to own a legally secure, nature-rich plot at affordable
                  pricing.
                </p>
              </div>
            </div>
            <div className="col-md-6 mt-4 mt-md-0">
              <div className="card shadow p-4 h-100">
                <h4 className="text-success">Our Vision</h4>
                <p>
                  To become the most trusted name in eco-friendly, gated community developments in
                  Telangana.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 💡 Section: Why Choose Us */}
      <section className="why-choose-us py-5 bg-light">
        <div className="container text-center">
          <h2 className="mb-4">Why Choose Us</h2>
          <div className="row">
            {[
              ["✅", "DTCP Approved Layout"],
              ["🏡", "Serene Riverfront Location"],
              ["💰", "₹350/day EMI Plans"],
              ["🌳", "7000+ Sandalwood Trees"],
              ["📜", "100% Clear Legal Title"],
              ["🛝", "Resort-Style Amenities"],
              ["🎁", "Referral Bonuses & Free Registration"],
              ["🛣", "50ft/40ft Blacktop Roads"],
            ].map(([icon, text], i) => (
              <div className="col-md-3 col-6 mb-4" key={i}>
                <div className="feature-card p-3 bg-white shadow-sm rounded h-100">
                  <div className="fs-1" role="img" aria-label={text}>
                    {icon}
                  </div>
                  <p className="mt-2">{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 📞 Section: Call to Action */}
      <div className="cta-section text-white text-center py-5 bg-success">
        <div className="container">
          <h2>Ready to own your dream plot?</h2>
          <p className="lead">
            Join the Nandanam Infra family today and invest in a secure, green future.
          </p>
          <div className="mt-4">
            <button className="btn btn-light me-3">Book Now</button>
            <button className="btn btn-outline-light me-3">Explore Venture</button>
            <button className="btn btn-outline-light">Contact Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
